<script>
  import {
    VBtn
  } from 'vuetify/lib'
  export default {
    name: 'wh-btn',
    extends: VBtn
  };
</script>